import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import {ProjectService} from '../service/project.service';
import {
  TableColumn,
  IdentifierTableColumn,
  DateTableColumn,
  MultiTableColumn,
  ButtonTableColumn,
  TableElement,
  TableComponent,
  DataReloadEvent,
  LoginService,
  CheckboxComponent,
  NativeStateComponent,
  ButtonComponentEvent,
  SelectDialogComponent
} from '@serengeti/serengeti-common';
import {Observable, Subject, Subscription} from 'rxjs';
import { RouterEvent, NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Label, SingleDataSet, monkeyPatchChartJsTooltip, monkeyPatchChartJsLegend } from 'ng2-charts';

import { InstanceQueryCondition, InstanceQueryHandler } from '@serengeti/serengeti-resource';
import { ResourceService } from '@serengeti/serengeti-resource';
import { InstanceService as ResourceInstanceService } from '@serengeti/serengeti-resource';
import { CatalogInstanceService as ResourceCatalogInstanceService } from '@serengeti/serengeti-resource';
import { CatalogInstanceService as SoftwareCatalogInstanceService } from '@serengeti/serengeti-app';
import { NotificationService, NotificationSubject } from '@serengeti/serengeti-notification';
import { ProjectTopologyService } from '../service/topology.service';
import {NgForm} from '@angular/forms';
import {TenantService, UserService} from "@serengeti/serengeti-user";

@Component({
	selector: 'app-service-project-detail',
	templateUrl: './detail.component.html',
	styleUrls: ['./detail.component.scss']
})
export class ProjectDetailComponent implements OnInit, OnDestroy, InstanceQueryHandler {

	types = [] as any[];
	project = {
		ownerId: null,
		id: null,
		name: null,
		owner: {
			id: null,
			userId: null,
			name: null
		},
		type: {
			id: null,
			name: null,
			attributes: [],
			constraints: []
		},
		activeState: null,
		quotas: [],
		tenant: {
			quotas: []
		},
		attributes: {},
		constraints: {},
		state: 'Active',
		description: null,
		elements: [],
		users: []
	};

	userImageSrc = '/assets/images/user/user.png' as any;
	defaultImageSrc = this.userImageSrc;

	id: string;
	searchUserName: string;
	searchResourceCatalogName: string;
	searchServiceCatalogName: string;

	userWithdraw = new ButtonTableColumn('service.project.detail.tabs.user.content.columns.status.action.withdraw', 'Control', 'primary')
	.withChecker((element: any) => {
		if (this.loginService.getLoginId() === this.project.owner.userId) {
			if (element.status === 'Pending') {
				if (this.id) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
	userRemove = new ButtonTableColumn('service.project.detail.tabs.user.content.columns.status.action.remove', 'Control', 'primary')
	.withChecker((element: any) => {
		if (this.loginService.getLoginId() === this.project.owner.userId) {
			if (element.status === 'Approved' || !this.id) {
				return true;
			} else {
				return false;
      }
		} else {
			return false;
		}
	});
	userApprove = new ButtonTableColumn('service.project.detail.tabs.user.content.columns.status.action.approve', 'Control', 'default')
	.withChecker((element: any) => {
		if (this.loginService.getLoginId() === this.project.owner.userId) {
			if (element.status === 'Requested') {
				if (this.id) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
      }
		} else {
			return false;
		}
	});
	userReject = new ButtonTableColumn('service.project.detail.tabs.user.content.columns.status.action.reject', 'Control', 'primary')
	.withChecker((element: any) => {
		if (this.loginService.getLoginId() === this.project.owner.userId) {
			if (element.status === 'Requested') {
				if (this.id) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			return false;
		}
	});

	_searchControl: ElementRef;
	@ViewChild('searchControl', { static: false }) set searchControl(_searchControl: ElementRef) {
		this._searchControl = _searchControl;
		if (_searchControl) {
			_searchControl.nativeElement.addEventListener('keypress', (e: KeyboardEvent) => {
				if (e.key === "Enter") {
					this.doResourceSearch();
				}
		 });
		}
	}

	get searchControl() : ElementRef {
		return this._searchControl;
	}

	currentResourceCondition: DataReloadEvent;
	resourceColumns: TableColumn[];
	resourceDetailColumn: TableColumn;

	_resourceCatalogList: TableComponent;
	@ViewChild('resourceCatalogList', {static: false}) set resourceCatalogList(_resourceCatalogList: TableComponent) {
		this._resourceCatalogList = _resourceCatalogList;
	}

	get resourceCatalogList(): TableComponent {
		return this._resourceCatalogList;
	}

	currentServiceCondition: DataReloadEvent;
	serviceColumns: TableColumn[];
	serviceDetailColumn: TableColumn;

	_serviceList: TableComponent;
	@ViewChild('serviceList', {static: false}) set serviceList(_serviceList: TableComponent) {
		this._serviceList = _serviceList;
	}

	get serviceList(): TableComponent {
		return this._serviceList;
	}

	currentUserCondition: DataReloadEvent;
	userColumns: TableColumn[];
	@ViewChild('userList', {static: false}) userList: TableComponent;

	routeSubscription: Subscription;
	notificationSubscription: Subscription;

	selectedIndex = 0;

	pieChartOptions: ChartOptions = {
		responsive: true,
		legend: {
			position: 'bottom'
		}
	};
	pieChartData: any[];
	pieChartType: ChartType = 'pie';
	pieChartLegend = true;
	pieChartPlugins = [];

	// total이 null이면 그 수준에는 상한이 없다 (JDC 설계 §2.2 "Empty means no limit", item 11):
	// 숫자 자리에 이 문구를 보여 준다. 프로젝트 목록의 사용률 column이 쓰는 문구와 같은 문자열이다
	// (serengeti.ui.common의 QuotaProgressTableColumn.NO_LIMIT, item 9).
	// 위험: library의 상수를 import 하지 않고 같은 문자열을 다시 쓴다. Nexus에는 item 9가 없는 1.1.67이
	//       남아 있어(item 9의 Notes), 그 version으로 shell을 빌드해도 compile이 깨지지 않게 하기 위해서다.
	// 위험: 번역 없이 한국어 문구를 그대로 쓴다 - item 9의 결정과 같게 맞춘 것이다.
	NO_LIMIT = '제한 없음';

	_topology: ElementRef;
	@ViewChild('topology', {static: false}) set topology(_topology: ElementRef) {
		this._topology = _topology;

		if (_topology) {
			$(_topology.nativeElement).removeClass('hide');
		}
	}
	get topology(): ElementRef {
		return this._topology;
	}

	user: any;

	@ViewChild('projectForm', {static: false}) private projectForm: NgForm;

	constructor(
		private dialog: MatDialog,
		private router: Router,
		private route: ActivatedRoute,
		private loginService: LoginService,
		private projectService: ProjectService,
		private userService: UserService,
		private tenantService: TenantService,
		private resourceService: ResourceService,
		private notificationService: NotificationService,
		private resourceInstanceService: ResourceInstanceService,
		private resourceCatalogInstanceService: ResourceCatalogInstanceService,
		private softwareCatalogInstanceService: SoftwareCatalogInstanceService,
		private topologyService: ProjectTopologyService,
		private translateService: TranslateService
	) {
		this.serviceColumns = [
			new IdentifierTableColumn('id', 'resource.catalog.detail.tabs.basic.content.columns.id')
			.withValueVisible(false).withType(CheckboxComponent),
			new TableColumn('name', 'resource.catalog.detail.tabs.basic.content.columns.instance-name'),
			new TableColumn('version', 'resource.catalog.detail.tabs.basic.content.columns.version')
			.withIgnoreSort(true).withStyles('cellCenter'),
			new TableColumn('status', 'resource.catalog.detail.tabs.basic.content.columns.state')
			.withType(NativeStateComponent)
			.withDecorator((_column: TableColumn, _element: TableElement) => {
				const state = TableColumn._getData(_element.getData(), 'status');
				if (state === 'Running') {
					_element.getData()._nativeState = 'status running';
					return 'resource.instance.common.state.running';
				} else if (state === 'Pending') {
					_element.getData()._nativeState = 'status pending';
					return 'resource.instance.common.state.pending';
				} else if (state === 'Starting') {
					_element.getData()._nativeState = 'status starting';
					return 'resource.instance.common.state.starting';
				} else if (state === 'Failed') {
					_element.getData()._nativeState = 'status failed';
					return 'resource.instance.common.state.failed';
				} else if (state === 'Error') {
					_element.getData()._nativeState = 'status error';
					return 'resource.instance.common.state.error';
				} else if (state === 'Terminated') {
					_element.getData()._nativeState = 'status terminated';
					return 'resource.instance.common.state.terminated';
				} else {
					_element.getData()._nativeState = 'status stopped';
					return 'resource.instance.common.state.stopped';
				}
			}),
			new DateTableColumn('createdDate', 'resource.catalog.detail.tabs.basic.content.columns.created-date')
			.withStyles('cellCenter'),
			new DateTableColumn('updatedDate', 'resource.catalog.detail.tabs.basic.content.columns.updated-date')
			.withStyles('cellCenter'),
			this.serviceDetailColumn = new ButtonTableColumn('resource.catalog.detail.tabs.basic.content.columns.detail',
			'resource.catalog.detail.tabs.basic.content.columns.detail', null, null, 'dehaze')
			.withIgnoreSort(true)
			.withStyles('cellCenter')
		];

		this.resourceColumns = [
			new IdentifierTableColumn('id', 'resource.catalog.detail.tabs.basic.content.columns.id')
			.withValueVisible(false).withType(CheckboxComponent),
			new TableColumn('name', 'resource.catalog.detail.tabs.basic.content.columns.instance-name'),
			new TableColumn('catalog.version', 'resource.catalog.detail.tabs.basic.content.columns.version')
			.withIgnoreSort(true).withStyles('cellCenter'),
			new TableColumn('state', 'resource.catalog.detail.tabs.basic.content.columns.state')
			.withType(NativeStateComponent)
			.withDecorator((_column: TableColumn, _element: TableElement) => {
				const state = TableColumn._getData(_element.getData(), 'state');
				if (state === 'Running') {
					_element.getData()._nativeState = 'status running';
					return 'resource.instance.common.state.running';
				} else if (state === 'Pending') {
					_element.getData()._nativeState = 'status pending';
					return 'resource.instance.common.state.pending';
				} else if (state === 'Failed') {
					_element.getData()._nativeState = 'status failed';
					return 'resource.instance.common.state.failed';
				} else if (state === 'Error') {
					_element.getData()._nativeState = 'status error';
					return 'resource.instance.common.state.error';
				} else if (state === 'Terminated') {
					_element.getData()._nativeState = 'status terminated';
					return 'resource.instance.common.state.terminated';
				} else {
					_element.getData()._nativeState = 'status stopped';
					return 'resource.instance.common.state.stopped';
				}
			}),
			new DateTableColumn('createdDate', 'resource.catalog.detail.tabs.basic.content.columns.created-date')
			.withStyles('cellCenter'),
			new DateTableColumn('updatedDate', 'resource.catalog.detail.tabs.basic.content.columns.updated-date')
			.withStyles('cellCenter'),
			this.resourceDetailColumn = new ButtonTableColumn('resource.catalog.detail.tabs.basic.content.columns.detail',
			'resource.catalog.detail.tabs.basic.content.columns.detail', null, null, 'dehaze')
			.withIgnoreSort(true)
			.withStyles('cellCenter')
		];

		this.userColumns = [
			new IdentifierTableColumn('id', 'service.project.detail.tabs.user.content.columns.select', false).withType(CheckboxComponent),
			new TableColumn('user.name', 'service.project.detail.tabs.user.content.columns.name'),
			new TableColumn('user.userId', 'service.project.detail.tabs.user.content.columns.userId'),
			new MultiTableColumn([
				new TableColumn('status', 'service.project.detail.tabs.user.content.columns.status')
					.withDecorator((self: TableColumn, element: TableElement) => {
						return 'service.project.detail.tabs.user.content.columns.status.state.' + element.getData().status;
					}),
				this.userWithdraw,
				this.userRemove,
				this.userApprove,
				this.userReject,
			], 'service.project.detail.tabs.user.content.columns.status.title').withStyles('cellCenter'),
		];

		this.routeSubscription = this.router.events.pipe(
			filter((event: RouterEvent) => event instanceof NavigationEnd)
		).subscribe(() => {
			this.notificationSubscription = this.notificationService
			.listenAll("ServiceProjectDetail",
			[ NotificationSubject.ResourceState, NotificationSubject.ResourceCatalogState, NotificationSubject.SoftwareCatalogState ] as string[])
			.subscribe((message: any) => {
				try {
					if (NotificationSubject.resourceTypes.includes(message.message.action.resourceType)) {
						if (this.id) {
							this.tenantService.get(this.id).subscribe((tenant: any) => {
								this.project.quotas = [];
								tenant.quotas.forEach((quota: any) => {
									const userQutoa = this._getUserQuota(quota.type);
									this.project.quotas.push({
										type: quota.type,
										request: quota.total,
										used: quota.used,
										reserved: quota.reserved,
										total: quota.total,
										userTotal: userQutoa.total,
										userReserved: userQutoa.reserved
									});
								});
								this.user.tenant.quotas.forEach((userQuota: any) => {
									for (const quota of this.project.tenant.quotas) {
										if (quota.type === userQuota.type) {
											return;
										}
									}
									const quota = userQuota;
                  this.project.quotas.push({
                    type: quota.type,
                    request: 0,
                    reserved: quota.reserved,
                    total: quota.total,
                    userReserved: quota.reserved,
                    userTotal: quota.total
                  });
								});
								this.doRefreshTopology();
								this.onChangeType();
							});
						}
					} else if (NotificationSubject.resourceCatalogType.includes(message.message.action.resourceType)) {
						this.doRefreshResource();
					} else if (NotificationSubject.softwareCatalogType.includes(message.message.action.resourceType)) {
						this.doRefreshService();
					}
				} catch (ex) {
					console.log(ex);
				}
			});

			this.projectService.user(this.loginService.getLoginId()).subscribe((user: any) => {
				this.user = user;
				this.projectService.types().subscribe((types: any[]) => {
					this.types = types;
					this.id = this.route.snapshot.paramMap.get('projectId');
					this.selectedIndex = this.loginService.getScreenConfig('project.detail', 'tabIndex', 0);

					if (this.id) {
						this.projectService.get(this.id).subscribe((project: any) => {
							this.project = project;
							this.project.quotas = [];

							if (this.project.tenant.quotas.length === 0) {
                this.user.tenant.quotas.filter((quota: any) => quota.type !== 'QuotaMoneyPerMonth').forEach((quota: any) => {
                  this.project.quotas.push({
                    type: quota.type,
                    request: 0,
                    reserved: quota.reserved,
                    total: quota.total,
                    userReserved: quota.reserved,
                    userTotal: quota.total
                  });
                });
							} else {
								this.project.tenant.quotas.forEach((quota: any) => {
                  const userQutoa = this._getUserQuota(quota.type);
                  this.project.quotas.push({
                    type: quota.type,
                    request: quota.total,
                    used: quota.used,
                    reserved: quota.reserved,
                    total: quota.total,
                    userTotal: userQutoa.total,
                    userReserved: userQutoa.reserved
                  });
                });
              }
              this.doRefreshTopology();
              this.onChangeType();
              this.project.type.attributes.sort((a, b) => {
                return -a.name.localeCompare(b.name);
              });
              this.doRefreshService();
              this.doRefreshResource();
              this.doRefreshUser();
            });
					} else {
						this.project.ownerId = this.loginService.getLoginId();
						this.project.owner.name = this.loginService.getLoginName();
						this.project.owner.userId = this.loginService.getLoginId();
						this.project.quotas = [];
						this.user.tenant.quotas.filter((quota: any) => quota.type !== 'QuotaMoneyPerMonth').forEach((quota: any) => {
							this.project.quotas.push({
								type: quota.type,
								request: 0,
								reserved: quota.reserved,
								total: quota.total,
								userReserved: quota.reserved,
								userTotal: quota.total
							});
						});
						if (this.types.length > 0) {
              this.project.type = this.types[0];
              this.project.type.attributes.sort((a, b) => {
                return -a.name.localeCompare(b.name);
              });
              this.onChangeType();
              this.doRefreshUser();
            }
          }
        });
      });
    });

		monkeyPatchChartJsTooltip();
		monkeyPatchChartJsLegend();
	}

	_getUserQuota(quotaType: string) {
		for (const quota of this.user.tenant.quotas) {
			if (quota.type === quotaType) {
				return quota;
			}
		}
		return null;
	}

	/**
	 * 프로젝트 폼의 최소값. 빈 칸은 "제한 없음"이므로 최소값 검사를 받지 않고, 숫자는 종전대로 현재
	 * 사용량 이상이어야 한다 (JDC 설계 §2.2 "Empty means no limit", implementation.md item 11).
	 *
	 * 왜 값을 그대로 돌려 주지 않고 valueOf()를 가진 객체를 돌려 주는가: 관계 연산자는 비교하는 그
	 * 순간에 valueOf()를 부르므로, 이 객체는 control이 그 때 들고 있는 값, 곧 화면의 값으로 판정한다.
	 * model(quota.request)은 validator가 다 돈 다음에야 updateControl이 쓰므로, model로 조건을 세우면
	 * 숫자를 지운 첫 순간에 이전 값으로 계산된 최소값(사용량)이 빈 칸에 적용되어 폼이 invalid가 되고
	 * doSave의 form gate가 저장을 막는다. item 11 step 5의 CJ-3t-2.7이 이 경로를 확인했다: 사용량 5인
	 * 프로젝트의 칸을 비워 저장하면 TOTAL null이 되고 사용량 5는 그대로다.
	 *
	 * 위험: customMin directive(serengeti.ui.common)가 `v < this.customMin`으로 비교한다는 데 기댄다.
	 *       directive가 값을 미리 Number(...)로 바꾸도록 바뀌면 빈 칸이 다시 막힌다.
	 * 위험: control 조회 key인 'quotaType' + quota.type은 template이 등록하는 이름
	 *       name="quotaType{{quota.type}}"(detail.component.html:116)과 같은 문자열이다. 한쪽
	 *       이름만 바뀌면 조회가 조용히 실패해 한 박자 전의 model 값으로 판정한다.
	 */
	quotaMin(quota: any): any {
		return {
			valueOf: () => {
				const control = this.projectForm && this.projectForm.controls ?
					this.projectForm.controls['quotaType' + quota.type] : null;
				// control이 아직 등록되기 전(첫 검사)에는 model 값이 곧 화면의 값이다.
				const value = control ? control.value : quota.request;

				if (value === null || value === undefined || value === '') {
					// 빈 칸에는 하한이 없다.
					return Number.NEGATIVE_INFINITY;
				}
				return quota.used ? quota.used.toFixed(0) : 0;
			}
		};
	}

	/**
	 * 프로젝트 폼의 최대값. 보는 사람의 행이 제한 없음(userTotal null)이면 상한이 없으므로 검사를
	 * 건너뛴다 (JDC 설계 §2.2 "Empty means no limit", item 11). 숫자 cap의 행은 종전 식 그대로다.
	 *
	 * 숫자 cap의 행에서 이 상한이 어떻게 판정하는지 측정했다 (item 11 step 5: build
	 * 20260906-043919-d9c9c9, run 20260906-050343, CJ-3t-2.1). 검사가 판정하는 순간의 상한은 이미 타자
	 * 친 값을 담고 있어 "타자 친 값 + (userTotal - userReserved)"로 계산된다. 그래서 소유자의
	 * 잔여량(userTotal - userReserved)이 음수일 때에만 상한이 타자 친 값보다 작고, 그 때에만 이 검사가
	 * 막는다. 그 음수 상태가 아래 defects #122 위험 줄의 초과 배정 상태다. cap이 0인 소유자 밑에서 CPU
	 * 8을 넣어도 폼은 막지 않았고 api.service의 417이 막았다. master에서도 같은 동작이 측정되므로
	 * (item 10 step 5) 종전 동작이고, 여기서 바꾸지 않는다.
	 *
	 * 위험: 건너뛸 때 undefined를 돌려 주어야 한다. customMax directive는 `v > this.customMax`로
	 *       비교하므로 null을 돌려 주면 v > 0 이 되어 모든 양수가 막힌다. undefined면 비교가 NaN이라
	 *       언제나 통과한다.
	 * 위험: 상한을 건너뛰면 폼은 그 자원에 대해 요청량을 미리 막지 않는다. 소유자 위의 상한은
	 *       api.user의 gate(item 3)와 api.service의 pre-check(item 8)가 그대로 지킨다.
	 * 위험: userTotal/userReserved는 로그인한 사용자의 default tenant 행이지 소유자의 행이 아니다
	 *       (defects #142). 서버가 받아 주는 유일한 caller인 소유자에게는 같은 행이고, item 28이
	 *       item 27의 helper로 이 figure들을 대신한다.
	 * 위험: 빈 칸도 이 상한 검사를 받는다(null > max 는 0 > max로 비교된다). defects #122의 초과 배정
	 *       상태(보는 사람의 RESERVED가 TOTAL + current보다 큼)에서는 상한이 음수라 빈 칸이 최소값
	 *       메시지와 함께 막힌다. master에서도 그 상태에서는 모든 숫자가 막히므로 새로 생긴 상태는
	 *       아니고, item 28이 폼의 client-side 상한/하한을 걷어낸다.
	 */
	quotaMax(quota: any): any {
		if (quota.userTotal === null || quota.userTotal === undefined) {
			return undefined;
		}
		// 프로젝트 행이 제한 없음(total null)이면 소유자 계정에 잡혀 있는 것은 이 행의 살아 있는 RESERVED다:
		// item 3의 cap transition이 옮기는 양이고, api.service의 pre-check가 빼는 항과 같다
		// (ServiceContainerServiceImpl.java:229-232, item 8). 숫자 cap의 행은 종전 식(직전 request)을 그대로 쓴다.
		// reserved는 replica 행의 것이며(ServiceUserQuotaEntity.java:90-91), 없으면 0.
		const current = (quota.total === null) ? (quota.reserved || 0) : quota.request;
		return (current + quota.userTotal - quota.userReserved).toFixed(0);
	}

	doRefreshTopology() {
		if (this.project) {
			const projects = [];

			projects.push(this.project);
			this.topologyService.build(this.topology, projects);
		}
	}

	ngOnInit() {
	}

	onTabChange() {
		this.loginService.setScreenConfig('project.detail', 'tabIndex', this.selectedIndex);
	}

	getConstraints(attributeId: string) {
		for (const constraint of this.project.type.constraints) {
			if (constraint.id === attributeId) {
				return constraint;
			}
		}
		return null;
	}

	getAttributes(attributeId: string) {
		for (const attribute of this.project.type.attributes) {
			if (attribute.id === attributeId) {
				return attribute;
			}
		}
		return null;
	}

	onChangeType() {
		let currentType = null;
		for (const type of this.types) {
			if (type.id === this.project.type.id) {
				currentType = type;
				break;
			}
		}

		if (!this.project.attributes) {
			this.project.attributes = {};
		}

		this.translateService.get([
			'setting.user.detail.tabs.quota.content.chart.quotacpu.title',
			'setting.user.detail.tabs.quota.content.chart.quotacpu.order',
      'setting.user.detail.tabs.quota.content.chart.quotacpu.legend.used',
      'setting.user.detail.tabs.quota.content.chart.quotacpu.legend.free',
      'setting.user.detail.tabs.quota.content.chart.quotamemory.title',
      'setting.user.detail.tabs.quota.content.chart.quotamemory.order',
      'setting.user.detail.tabs.quota.content.chart.quotamemory.legend.used',
      'setting.user.detail.tabs.quota.content.chart.quotamemory.legend.free',
      'setting.user.detail.tabs.quota.content.chart.quotadisk.title',
      'setting.user.detail.tabs.quota.content.chart.quotadisk.order',
      'setting.user.detail.tabs.quota.content.chart.quotadisk.legend.used',
      'setting.user.detail.tabs.quota.content.chart.quotadisk.legend.free',
      'setting.user.detail.tabs.quota.content.chart.quotagpu.title',
      'setting.user.detail.tabs.quota.content.chart.quotagpu.order',
      'setting.user.detail.tabs.quota.content.chart.quotagpu.legend.used',
      'setting.user.detail.tabs.quota.content.chart.quotagpu.legend.free',
      'setting.user.detail.tabs.quota.content.chart.quotamoneypermonth.title',
      'setting.user.detail.tabs.quota.content.chart.quotamoneypermonth.order',
      'setting.user.detail.tabs.quota.content.chart.quotamoneypermonth.legend.used',
      'setting.user.detail.tabs.quota.content.chart.quotamoneypermonth.legend.free'
    ]).subscribe((messages: any) => {
			this.pieChartData = [];

			const quotas = [];
			for (const displayQuota of environment.content.displayQuotas) {
				const quota = this._getQuota(this.project.quotas, displayQuota.type);
				if (quota) {
          // total이 null이면 상한이 없다 (JDC 설계 §2.2 "Empty means no limit", item 11): 남은 양을
          // 계산할 수 없으므로 pie를 그리지 않고 template이 "제한 없음" 문구를 대신 보여 준다.
          // undefined(행 자체가 없음)는 종전 그대로 둔다 - item 9의 사용률 column과 같은 구분이다.
          const unlimited = (quota.total === null);
          const pieChart = {
            id: quota.type,
            name: quota.type,
            unlimited: unlimited,
            data: [quota.used, unlimited ? 0 : quota.total - quota.used] as SingleDataSet,
            labels: [
              messages['setting.user.detail.tabs.quota.content.chart.' + quota.type.toLowerCase() + '.legend.used'],
              messages['setting.user.detail.tabs.quota.content.chart.' + quota.type.toLowerCase() + '.legend.free']
            ] as Label[]
          };

          this.pieChartData.push(pieChart);

          quotas.push(quota);
        }
			}
			this.project.quotas = quotas;
		});
	}

	_getQuota(quotas: any[], quotaType: string) {
		for (const quota of quotas) {
			if (quota.type === quotaType) {
				return quota;
			}
		}
		return null;
	}

	onTabAnimation() {
		if (this.selectedIndex === 4) {
			this.doRefreshUser();
		} else if (this.selectedIndex === 5) {
			this.doRefreshTopology();
		}
	}

	doInviteUser() {
		const inviteDialogRef = this.dialog.open(SelectDialogComponent, {
			width: '80%',
			height: '80%',
			data: {
				title: "service.project.detail.tabs.user.dialog.invite.title",
				query: environment.serviceUserEndPoint + 'user/search',
				method: 'page',
				columns: [
					new IdentifierTableColumn('userId', 'service.project.detail.tabs.user.dialog.invite.content.columns.userId').withType(CheckboxComponent),
					new TableColumn('username', 'service.project.detail.tabs.user.dialog.invite.content.columns.name'),
					new DateTableColumn('createdDate', 'service.project.detail.tabs.user.dialog.invite.content.columns.created-date')
				],
				selectButtonLabel: 'service.project.detail.tabs.user.dialog.invite.button.invite'
			}
		});

		inviteDialogRef.afterClosed().subscribe(selectedUsers => {
			if (selectedUsers && selectedUsers.result === true && selectedUsers.data.length > 0) {
				if (!this.project.users) {
					this.project.users = [];
				}

				const userIds = selectedUsers.data.map((user: any) => user.getData().userId);

				if (this.id) {
					this.translateService.get(['service.project.detail.tabs.user.confirm.invite',
					'service.project.detail.tabs.user.alert.invite-ok',
					'service.project.detail.tabs.user.alert.invite-duplicated',
					'service.project.detail.tabs.user.alert.invite-failed']).subscribe((messages: any) => {
						if (confirm(messages['service.project.detail.tabs.user.confirm.invite'])) {
              this.projectService.inviteAll(this.id, userIds).subscribe((projectMembers: any) => {
                projectMembers.forEach((projectMember: any) => this.project.users.push(projectMember));
                alert(messages['service.project.detail.tabs.user.alert.invite-ok']);
                this.doRefreshUser();
              }, (error: any) => {
                if (error.status === 417) {
                  alert(messages['service.project.detail.tabs.user.alert.invite-duplicated']);
                } else {
                  alert(messages['service.project.detail.tabs.user.alert.invite-failed']);
                }
              });
						}
					});
				} else {
          selectedUsers.data.forEach((user: any) => {
            this.project.users.push({
              user: {
                userId: user.getData().userId,
                name: user.getData().username
              },
              status: 'Pending',
              createdDate: new Date()
            });
          });
        }
        this.doRefreshUser();
      }
    });
	}

	onUserButtonClicked($buttonEvent: ButtonComponentEvent) {
		const userId = TableColumn._getData($buttonEvent.element.getData(), "user.userId");
		const name = TableColumn._getData($buttonEvent.element.getData(), "user.name");
		let action = null;

		if ($buttonEvent.column === this.userWithdraw) {
			action = 'withdraw';
		} else if ($buttonEvent.column === this.userReject) {
			action = 'reject';
		} else if ($buttonEvent.column === this.userApprove) {
			action = 'approve';
		} else if ($buttonEvent.column === this.userRemove) {
			action = 'remove';
		}

		if (action) {
			this.translateService.get([
				'service.project.detail.tabs.user.confirm.' + action,
				'service.project.detail.tabs.user.alert.' +  action + '-ok',
				'service.project.detail.tabs.user.alert.' +  action + '-invalid-user',
				'service.project.detail.tabs.user.alert.' +  action + '-failed'
			], { "name": name }).subscribe((messages: string) => {
				if (confirm(messages['service.project.detail.tabs.user.confirm.' + action])) {
					if (this.id) {
						if (action === 'withdraw') {
							this.projectService.withdraw(this.id, userId).subscribe(() => {
								alert(messages['service.project.detail.tabs.user.alert.' + action + '-ok']);
								const index = this.project.users.indexOf($buttonEvent.getElement().getData());

								if (index != -1) {
									this.project.users.splice(index, 1);
									this._doRefreshUser(this.currentUserCondition);
								}
							}, (error: any) => {
								if (error.status === 417) {
									alert(messages['service.project.detail.tabs.user.alert.' + action + '-invalid-user']);
								} else {
									alert(messages['service.project.detail.tabs.user.alert.' + action + '-failed']);
								}
							});
						} else if (action === 'reject') {
							this.projectService.reject(this.id, userId).subscribe(() => {
								alert(messages['service.project.detail.tabs.user.alert.' + action + '-ok']);
								const index = this.project.users.indexOf($buttonEvent.getElement().getData());

								if (index != -1) {
									this.project.users.splice(index, 1);
									this._doRefreshUser(this.currentUserCondition);
								}
							}, (error: any) => {
								if (error.status === 417) {
									alert(messages['service.project.detail.tabs.user.alert.' + action + '-invalid-user']);
								} else {
									alert(messages['service.project.detail.tabs.user.alert.' + action + '-failed']);
								}
							});
						} else if (action === 'approve') {
							this.projectService.approve(this.id, userId).subscribe(() => {
								alert(messages['service.project.detail.tabs.user.alert.' + action + '-ok']);
								const projectMember = $buttonEvent.getElement().getData();

								projectMember.status = 'Approved';
								this._doRefreshUser(this.currentUserCondition);
							}, (error: any) => {
								if (error.status === 417) {
									alert(messages['service.project.detail.tabs.user.alert.' + action + '-invalid-user']);
								} else {
									alert(messages['service.project.detail.tabs.user.alert.' + action + '-failed']);
								}
							});
						} else if (action === 'remove') {
							this.projectService.remove(this.id, userId).subscribe(() => {
								alert(messages['service.project.detail.tabs.user.alert.' + action + '-ok']);
								const index = this.project.users.indexOf($buttonEvent.getElement().getData());

								if (index != -1) {
									this.project.users.splice(index, 1);
									this._doRefreshUser(this.currentUserCondition);
								}
							}, (error: any) => {
								if (error.status === 417) {
									alert(messages['service.project.detail.tabs.user.alert.' + action + '-invalid-user']);
								} else {
									alert(messages['service.project.detail.tabs.user.alert.' + action + '-failed']);
								}
							});
						}
					}
				}
			});
		}
	}

	doRefreshUser() {
		const sortItem = this.loginService.getScreenConfig('project.detail.user', 'sortItem');
		const sortOrder = this.loginService.getScreenConfig('project.detail.user', 'sortOrder');

    this._doRefreshUser(new DataReloadEvent((sortItem ? sortItem : 'user.name'), (sortOrder ? sortOrder : 'desc'),
      0, 15, this.searchUserName));
		if (this.project.owner && this.project.owner.userId) {
			this.userService.loadIcon(this.project.owner.userId).subscribe(image => {
				if (image) {
					if (image.size !== 0) {
						const reader = new FileReader();
						const self = this;

						reader.onload = () => {
              self.userImageSrc = reader.result;
            };
            reader.onerror = () => {
              self.userImageSrc = this.defaultImageSrc;
            };
            reader.readAsDataURL(image);
          } else {
            this.userImageSrc = this.defaultImageSrc;
          }
        }
      });
		}
}

	_doRefreshUser(condition: DataReloadEvent) {
		if (condition) {
			this.currentUserCondition = condition;
		} else {
			condition = this.currentUserCondition;
		}
		if (condition.pageNumber === 0) {
			this.loginService.setScreenConfig('project.detail.user', 'sortItem', condition.active);
			this.loginService.setScreenConfig('project.detail.user', 'sortOrder', condition.sortOrder);
		}
		if (this.userList) {
      this.userList.refreshData(this.project.users,
        this.userColumns, condition);
		}
	}

	doSearchResourceList(condition?: InstanceQueryCondition): Observable<any[]> {
		let sortItem = null;
		let sortOrder = 'asc';
		let pageNumber = 0;
		let pageSize = 10;

		if (condition.condition) {
			sortItem = condition.condition.active;
			sortOrder = condition.condition.sortOrder;
			pageNumber = condition.condition.pageNumber,
			pageSize = condition.condition.pageSize;
		}

		const resourceListSubject = new Subject<any[]>();
		const tenantIds = [];

		tenantIds.push(this.id);

		this.resourceInstanceService.tenant(tenantIds, condition.filter,
				sortItem, sortOrder, pageNumber, pageSize).subscribe((resources: any) => {
			resourceListSubject.next(resources);
		});

		return resourceListSubject;
	}

  doRefreshService(condition?: DataReloadEvent) {
		if (!condition) {
			const sortItem = this.loginService.getScreenConfig('project.detail.service', 'sortItem');
			const sortOrder = this.loginService.getScreenConfig('project.detail.service', 'sortOrder');

      condition = new DataReloadEvent((sortItem ? sortItem : 'name'), (sortOrder ? sortOrder : 'desc'), 0, 15, this.searchServiceCatalogName);
		}

		if (condition) {
			this.currentResourceCondition = condition;
		} else {
			condition = this.currentResourceCondition;
		}
		if (condition.pageNumber === 0) {
			this.loginService.setScreenConfig('project.detail.service', 'sortItem', condition.active);
			this.loginService.setScreenConfig('project.detail.sevice', 'sortOrder', condition.sortOrder);
		}

    if (this.serviceList) {
			const tenantIds = [];

			tenantIds.push(this.id);
			this.softwareCatalogInstanceService.search(tenantIds, null, null, condition.filter, condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize).subscribe((resultPage: any) => {
				this.serviceList.refresh(resultPage.totalElements, resultPage.content, this.serviceColumns, condition);
			});
		}
	}

	doRefreshResource(condition?: DataReloadEvent) {
		if (!condition) {
			const sortItem = this.loginService.getScreenConfig('project.detail.resource', 'sortItem');
			const sortOrder = this.loginService.getScreenConfig('project.detail.resource', 'sortOrder');

      condition = new DataReloadEvent((sortItem ? sortItem : 'name'), (sortOrder ? sortOrder : 'desc'), 0, 15, this.searchResourceCatalogName);
		}

		this.doRefresh(condition);
	}

	goBack() {
		this.router.navigate(['/main', { outlets: { content: 'service/project/list' }}]);
	}

	doShowResources($event: any) {
		const element = $event.element.getData();

		if (element.type === 'ServiceResource') {
			this.router.navigate(['/main', { outlets: { content: 'resource/instance/detail/' + element.elementId + '/' }}]);
		} else {
			this.router.navigate(['/main', { outlets: { content: 'catalog/instance/detail/' + element.elementId + '/' }}]);
		}
	}

	ngOnDestroy() {
		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
		if (this.notificationSubscription) {
			this.notificationSubscription.unsubscribe();
		}
	}

	doRefresh(condition: DataReloadEvent) {
		if (condition) {
			this.currentResourceCondition = condition;
		} else {
			condition = this.currentResourceCondition;
		}
		if (condition.pageNumber === 0) {
			this.loginService.setScreenConfig('project.detail.resource', 'sortItem', condition.active);
			this.loginService.setScreenConfig('project.detail.resource', 'sortOrder', condition.sortOrder);
		}

    if (this.resourceCatalogList) {
			const tenantIds = [];
			tenantIds.push(this.id);

			this.resourceCatalogInstanceService.instances(tenantIds, condition.filter, condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize).subscribe((resultPage: any) => {
				this.resourceCatalogList.refresh(resultPage.totalElements, resultPage.content, this.resourceColumns, condition);
			});
		}
	}

	doDelete() {
		this.translateService.get(['service.project.detail.confirm.delete',
		'service.project.detail.alert.remaining-resources',
		'service.project.detail.alert.remaining-users',
		'service.project.detail.alert.deleted',
		'service.project.detail.alert.delete-failed']).subscribe((messages: any) => {
			let resourceRemained = false;

			this.project.tenant.quotas.forEach((quota: any) => {
				if (quota.used > 0) {
					resourceRemained = true;
				}
			});
			if (resourceRemained) {
				alert(messages['service.project.detail.alert.remaining-resources']);
				return;
			}

      if (this.project.users && this.project.users.length > 0
        && !(this.project.users.length === 1 && this.project.users[0].userId === this.loginService.getLoginId())) {
        alert(messages['service.project.detail.alert.remaining-users']);
        return;
      } else {
        this.resourceService.checkDelete(this.id).subscribe(() => {
          if (confirm(messages['service.project.detail.confirm.delete'])) {
            this.projectService.delete(this.id).subscribe(() => {
              alert(messages['service.project.detail.alert.deleted']);
              this.router.navigate(['/main', {outlets: {content: 'service/project/list'}}]);
            }, (error: any) => {
              alert(messages['service.project.detail.alert.delete-failed']);
            });
          }
				}, (error: any) => {
					if (error.status === 417) {
						alert(messages['service.project.detail.alert.remaining-resources']);
						// this.router.navigate(['/main', { outlets: { content: 'resource/status/list' }}]);
          }
				});
			}
		});
	}

  doSave() {
		this.translateService.get([
			'common.invalid.alert',
			'service.project.detail.confirm.save',
			'service.project.detail.alert.missing-name',
			'service.project.detail.alert.saved',
			'service.project.detail.alert.quota-exceeded',
			'service.project.detail.alert.save-failed'
		]).subscribe((messages: any) => {
			if (!this.projectForm.valid) {
				if (this.projectForm.controls) {
					for (const control in this.projectForm.controls) {
						this.projectForm.controls[control].markAsTouched();
					}
				}
				alert(messages['common.invalid.alert']);
				return;
			} else {
				if (!this.project.name || this.project.name.trim().length === 0) {
					alert(messages['service.project.detail.alert.missing-name']);
					return;
				}
				if (confirm(messages['service.project.detail.confirm.save'])) {
          this.projectService.save(this.id, this.project).subscribe((project: any) => {
            alert(messages['service.project.detail.alert.saved']);
            this.router.navigate(['/main', {outlets: {content: 'service/project/list'}}]);
          }, (error: any) => {
            if (error.status === 417) {
              alert(messages['service.project.detail.alert.quota-exceeded']);
            } else {
              alert(messages['service.project.detail.alert.save-failed']);
            }
          });
        }
			}
		});
	}

	doValidateQuota(totalCpu: number, totalMemory: number, totalDisk: number) {
		const validateItems = ['CPU', 'MEMORY', 'DISK'];
		const validateValues = [totalCpu, totalMemory, totalDisk];

		for (const [index, item] of validateItems.entries()) {
			const attribute = this.getAttributes(item);
			const constraint = this.getConstraints(item);
			const validateValue = validateValues[index];

      if (parseFloat(this.project.attributes[attribute.name]) + validateValue >= parseFloat(this.project.constraints[constraint.name])) {
				return item;
			}
		}
		return null;
	}

  doServiceLaunch() {
		this.router.navigate(['/main', { outlets: { content: 'service/project/detail/' + this.id + '/launcher' }}]);
	}

	doServiceSearch() {
		this.doRefreshService();
	}

	onServiceHandleButtonClick($event: any) {
		if ($event.column === this.serviceDetailColumn) {
			this.router.navigate(['/main', { outlets: { content: 'software/catalog/instance/detail/' + $event.element.getData().id + '/' }}]);
		}
	}

  doServiceTerminate() {
		this.translateService.get(['software.catalog.instance.list.alert.invalid-terminating-instances',
		'software.catalog.instance.list.alert.terminating-instances-started',
		'software.catalog.instance.list.confirm.terminate-instances']).subscribe((messages: any) => {
			let invalidInstances = false;
			const selectedInstances = [];
			this.serviceList.getElements().forEach((element: TableElement) => {
				if (element.isSelected()) {
					const instance = element.getData();

          if (instance.status === 'Terminated') {
						invalidInstances = true;
					} else {
						selectedInstances.push(element.getData());
					}
				}
			});

      if (invalidInstances) {
				alert(messages['software.catalog.instance.list.alert.invalid-terminating-instances']);
			} else {
				if (confirm(messages['software.catalog.instance.list.confirm.terminate-instances'])) {
					selectedInstances.forEach((catalogInstance: any) => {
						this.softwareCatalogInstanceService.terminate(catalogInstance.id).subscribe(() => {});
					});
					alert(messages['software.catalog.instance.list.alert.terminating-instances-started']);
				}
			}
		});
	}

	doServiceDelete() {
		this.translateService.get(['software.catalog.instance.list.alert.invalid-deleting-instances',
		'software.catalog.instance.list.alert.deleting-instances-started',
		'software.catalog.instance.list.confirm.delete-instances']).subscribe((messages: any) => {
			let invalidInstances = false;
			const selectedInstances = [];
			this.serviceList.getElements().forEach((element: TableElement) => {
				if (element.isSelected()) {
					const instance = element.getData();

          if (instance.status === 'Terminated') {
						selectedInstances.push(element.getData());
					} else {
						invalidInstances = true;
					}
				}
			});

      if (invalidInstances) {
				alert(messages['software.catalog.instance.list.alert.invalid-deleting-instances']);
			} else {
				if (confirm(messages['software.catalog.instance.list.confirm.delete-instances'])) {
					selectedInstances.forEach((catalogInstance: any) => {
						this.softwareCatalogInstanceService.delete(catalogInstance.id).subscribe(() => {
							this.doRefreshService();
						});
					});
					alert(messages['software.catalog.instance.list.alert.deleting-instances-started']);
				}
			}
		});
	}

	doResourceLaunch() {
		this.translateService.get(['resource.catalog.detail.alert.quota-limit-exceeded',
		'resource.catalog.detail.alert.launch-failed']).subscribe((messages: any) => {
			this.resourceCatalogInstanceService.launch(null, this.id).subscribe((createdInstance: any) => {
        this.translateService.get('resource.catalog.detail.alert.launch-ok', {name: createdInstance.name}).subscribe((message: string) => {
          alert(message);
        });
        return;
      }, (error: any) => {
        if (error.status === 417) {
          alert(messages['resource.catalog.detail.alert.quota-limit-exceeded']);
        } else {
          alert(messages['resource.catalog.detail.alert.launch-failed']);
        }
      });
		});
	}

	doResourceSearch() {
		this.doRefreshResource();
	}

	onResourceHandleButtonClick($event: any) {
		if ($event.column === this.resourceDetailColumn) {
			this.router.navigate(['/main', { outlets: { content: 'resource/catalog/detail/' + this.id + '/instance/' + $event.element.getData().id + '/' }}]);
		}
	}

  doResourceDelete() {
		this.translateService.get(['resource.catalog.detail.alert.invalid-deleting-instances',
		'resource.catalog.detail.alert.deleting-instances-started',
		'resource.catalog.detail.confirm.delete-instances']).subscribe((messages: any) => {
			let invalidInstances = false;
			const selectedInstances = [];
			this.resourceCatalogList.getElements().forEach((element: TableElement) => {
				if (element.isSelected()) {
					const instance = element.getData();

          if (instance.state === 'Terminated') {
						selectedInstances.push(element.getData());
					} else {
						invalidInstances = true;
					}
				}
			});

      if (invalidInstances) {
				alert(messages['resource.catalog.detail.alert.invalid-deleting-instances']);
			} else {
				if (confirm(messages['resource.catalog.detail.confirm.delete-instances'])) {
					selectedInstances.forEach((catalogInstance: any) => {
						this.resourceCatalogInstanceService.delete(catalogInstance.id).subscribe(() => {
							this.doRefreshResource();
						});
					});
					alert(messages['resource.catalog.detail.alert.deleting-instances-started']);
				}
			}
		});
	}

	doResourceTerminate() {
		this.translateService.get(['resource.catalog.detail.alert.invalid-terminating-instances',
		'resource.catalog.detail.alert.terminating-instances-started',
		'resource.catalog.detail.confirm.terminate-instances']).subscribe((messages: any) => {
			let invalidInstances = false;
			const selectedInstances = [];
			this.resourceCatalogList.getElements().forEach((element: TableElement) => {
				if (element.isSelected()) {
					const instance = element.getData();

          if (instance.state === 'Terminated') {
						invalidInstances = true;
					} else {
						selectedInstances.push(element.getData());
					}
				}
			});

      if (invalidInstances) {
				alert(messages['resource.catalog.detail.alert.invalid-terminating-instances']);
			} else {
				if (confirm(messages['resource.catalog.detail.confirm.terminate-instances'])) {
					selectedInstances.forEach((catalogInstance: any) => {
						this.resourceCatalogInstanceService.terminate(catalogInstance.id).subscribe(() => {});
					});
					alert(messages['resource.catalog.detail.alert.terminating-instances-started']);
				}
			}
		});
	}
}
